import { useEffect, useState } from "react";
import Input from "./Input";
import { isoToJalali } from "../../../helper/isoToJalali";
import SVG from "../../../Components/SVG";

export default function InformationCard({ usersData }) {
  return (
    <div className="w-full max-w-3xl rounded-2xl p-4 flex flex-col gap-6 bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <div className="w-full flex items-start justify-between">
        <span className="font-medium text-xl text-zi-text-light dark:text-zi-text-dark">
          اطلاعات شخصی
        </span>
        <SVG
          name="profilePicture"
          classname="size-16 stroke-zi-text-light dark:stroke-zi-text-dark h-fill aspect-square"
        />
      </div>

      <form className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-6">
        <Input
          label="نام"
          inputSample={usersData?.userinfo?.fn || ""}
          value={usersData?.userinfo?.fn || ""}
          type="text"
          id="fn"
          name="fn"
          isReadOnly={true}
          isAuotComplete={true}
        />
        <Input
          label="نام خانوادگی"
          inputSample={usersData?.userinfo?.ln || ""}
          value={usersData?.userinfo?.ln || ""}
          type="text"
          id="ln"
          name="ln"
          isReadOnly={true}
          isAuotComplete={true}
        />
        <Input
          label="کد ملی"
          inputSample={usersData?.userinfo?.national_id || ""}
          value={usersData?.userinfo?.national_id || ""}
          type="text"
          id="id"
          name="id"
          isReadOnly={true}
          isAuotComplete={true}
        />
        <Input
          label="تاریخ تولد"
          inputSample={
            usersData?.userinfo?.birth_date
              ? usersData?.userinfo?.birth_date
              : ""
          }
          value={usersData?.userinfo?.birth_date || ""}
          type="date"
          id="bd"
          name="bd"
          isReadOnly={true}
          isAuotComplete={true}
        />
        <Input
          label="آدرس ایمیل"
          inputSample={usersData?.email || ""}
          value={usersData?.email || ""}
          type="email"
          id="email"
          name="email"
          isReadOnly={true}
          isAuotComplete={true}
        />
        <Input
          label="شماره تلفن همراه"
          inputSample={usersData?.userinfo?.phone_number || ""}
          value={usersData?.userinfo?.phone_number || ""}
          type="tel"
          id="tel"
          name="tel"
          isReadOnly={true}
          isAuotComplete={true}
          isLTR={true}
        />
      </form>
    </div>
  );
}
